import React from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from "@mui/material/Box";
import { ApaRefenceStyles } from "./ApaReferenceAccordion.styles";

const ApaReferenceAccordion = ({ apaData }) => {
  return (
    <Box sx={ApaRefenceStyles}>
      <div className={"chartFooter__bibliographicReferences"}>
        <div className={"apaReference"}>
          {
            apaData.source && apaData.source.length > 1 ?
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${apaData.source[0].r_text}-content`}
                  id={`panel-${apaData.source[0].r_text}-header`}
                >
                  <strong>See references</strong>
                </AccordionSummary>
                <AccordionDetails>
                <p>
                    {apaData.source[0].apa_ref}
                  </p>
                </AccordionDetails>
              </Accordion>
              :
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${apaData.source.r_text}-content`}
                  id={`panel-${apaData.source.r_text}-header`}
                >
                  <strong>See references</strong>
                </AccordionSummary>
                <AccordionDetails>
                  <p>
                    {apaData.source.apa_ref}
                  </p>
                </AccordionDetails>
              </Accordion>
          }
          {
            apaData.source_compare &&
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel-${apaData.source.r_text}-content`}
                id={`panel-${apaData.source.r_text}-header`}
              >
                <strong>{apaData.source_compare.r_text}</strong>
              </AccordionSummary>
              <AccordionDetails>
                {apaData.source_compare.apa_ref}
              </AccordionDetails>
            </Accordion>
          }
        </div>
      </div>
    </Box>
  )
}

export default ApaReferenceAccordion;
